import { Box, TextBox } from '@superdispatch/ui-lab';
import NoDamagesIcon from '../assets/no-damages-vehicle.svg';
import NoDamagesIconDark from '../assets/no-damages-vehicle-dark.svg';
import { Image, Stack } from '@superdispatch/ui';

export function ViewLoadInspectionNoDamages() {
  return (
    <Box padding="small">
      <Stack space="small" align="center">
        <Image
          src={NoDamagesIcon}
          srcDark={NoDamagesIconDark}
          alt="No Damages"
        />
        <TextBox color="secondary">No Damages</TextBox>
      </Stack>
    </Box>
  );
}
